export const normalizeCatalogText = value => value.toLocaleLowerCase('es').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
export const assistanceCount = group => group.sections.reduce((total, section) => total + section.items.length, 0);

const aliases = { psicologia: 'psicolog', psicologo: 'psicolog', psicologa: 'psicolog', nutricion: 'nutricional', nutricionista: 'nutricional', veterinario: 'veterinar', veterinaria: 'veterinar', plomeria: 'fontaneria', gasfiteria: 'fontaneria', gasfiter: 'fontaneria', cerrajero: 'cerrajeria', cristales: 'cristaleria' };
export const filterAssistanceGroups = (groups, search, category) => {
  const terms = normalizeCatalogText(search.trim()).split(/\s+/).filter(Boolean).map(term => aliases[term] || term);
  return groups.filter(group => category === 'all' || group.id === category).map(group => ({
    ...group,
    sections: group.sections.map(section => ({
      ...section,
      items: section.items.filter(item => {
        const text = normalizeCatalogText(`${group.label} ${section.title} ${item.label}`);
        return terms.every(term => text.includes(term));
      }),
    })).filter(section => section.items.length),
  })).filter(group => group.sections.length);
};